import * as CookieConsent from "vanilla-cookieconsent";

/**
 * All config. options available here:
 * https://cookieconsent.orestbida.com/reference/configuration-reference.html
 */
CookieConsent.run({
    disablePageInteraction: true,
    // root: 'body',
    // autoShow: true,
    // disablePageInteraction: true,
    // hideFromBots: true,
    // mode: 'opt-in',
    // revision: 0,

    // cookie: {
    //     name: 'cc_cookie',
        // domain: location.hostname,
        // path: '/',
        // sameSite: "Lax",
        // expiresAfterDays: 365,
    // },

    // https://cookieconsent.orestbida.com/reference/configuration-reference.html#guioptions
    guiOptions: {
        consentModal: {
            layout: 'box wide',
            position: 'bottom center',
            equalWeightButtons: false,
            flipButtons: false,
            transition: 'slide'
        },
        preferencesModal: {
            layout: 'box',
            equalWeightButtons: false,
            flipButtons: false,
            transition: 'slide'
        }
    },

    onFirstConsent: ({cookie}) => {
        registerCookiePreference(cookie)
    },

    onConsent: ({cookie}) => {
        // updateGtagConsent();
        // updateFBConsent();
    },

    onChange: ({changedCategories, changedServices}) => {
        registerCookiePreference(changedCategories)
        // updateGtagConsent();
        // updateFBConsent();
    },

    // onModalReady: ({modalName}) => {
    //     console.log('ready:', modalName);
    // },
    //
    // onModalShow: ({modalName}) => {
    //     console.log('visible:', modalName);
    // },
    //
    // onModalHide: ({modalName}) => {
    //     console.log('hidden:', modalName);
    // },

    categories: {
        necessary: {
            enabled: true,  // this category is enabled by default
            readOnly: true  // this category cannot be disabled
        },
        analytics: {
            autoClear: {
                cookies: [
                    {
                        name: /^_ga/,   // regex: match all cookies starting with '_ga'
                    },
                    {
                        name: '_gid',   // string: exact cookie name
                    }
                ]
            },

            // https://cookieconsent.orestbida.com/reference/configuration-reference.html#category-services
            // services: {
                // ga: {
                //     label: 'Google Analytics',
                //     onAccept: () => {},
                //     onReject: () => {}
                // },
                // youtube: {
                //     label: 'Youtube Embed',
                //     onAccept: () => {},
                //     onReject: () => {}
                // },
            // }
        },
        targeting: {}
    },

    language: {
        default: 'it',
        autoDetect: 'document',
        translations: {
            it: {
                consentModal: {
                    title: ' I Cookie rendono le cose migliori!',
                    description: 'Utilizziamo cookie e identificatori di prima o terza parte con il tuo consenso e/o nostro interesse legittimo, allo scopo di immagazzinare o accedere alle informazioni sul tuo dispositivo, per raccogliere dati personali degli utenti per sviluppare e migliorare prodotti, nonché per visualizzare e misurare pubblicità  nostra e/o di terzi e/o contenuti personalizzati basati sulla tua navigazione (ad esempio le pagine visitate).', //
                    acceptAllBtn: 'Accetto tutti i Cookie',
                    acceptNecessaryBtn: 'Rifiuta tutti',
                    showPreferencesBtn: 'Impostazioni',
                    equalWeightButtons: false
                    // closeIconLabel: 'Reject all and close modal',
                },
                preferencesModal: {
                    title: 'Centro preferenze sulla privacy',
                    acceptAllBtn: 'Accetta tutti',
                    acceptNecessaryBtn: 'Rifiuta tutti',
                    savePreferencesBtn: 'Salva le impostazioni',
                    closeIconLabel: 'Chiudi',
                    serviceCounterLabel: 'Servizio|Servizi',
                    equalWeightButtons: false,
                    sections: [
                        {
                            title: 'Opzioni Cookie',
                            description: 'Questo sito Web utilizza cookie essenziali per garantirne il corretto funzionamento e cookie di tracciamento per capire come interagisci con esso. Quest\'ultimo sarà impostato solo previo consenso.'
                        },
                        {
                            title: 'Cookie strettamente necessari',
                            description: 'Questi cookie sono necessari per il funzionamento del sito e non possono essere disattivati nei nostri sistemi. Di solito vengono impostati solo in risposta alle azioni da te effettuate che costituiscono una richiesta di servizi, come l\'impostazione delle preferenze di privacy, l\'accesso o la compilazione di moduli. È possibile impostare il browser per bloccare o avere avvisi riguardo questi cookie, ma di conseguenza alcune parti del sito non funzioneranno. Questi cookie non archiviano informazioni personali.',
                            linkedCategory: 'necessary',
                            cookieTable: {
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Dominio',
                                    desc: 'Descrizione',
                                },
                                body: [
                                    {
                                        name: 'october_session',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Conserva lo stato della sessione del visitatore tra le richieste di pagina.',
                                    },
                                    {
                                        name: 'cc_cookie',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Memorizza lo stato del consenso ai cookie dell\'utente per il dominio corrente.',
                                    },
                                    {
                                        name: 'user_auth',
                                        domain: window.location.hostname,
                                        desc: 'HTTP - Memorizza informazioni sull\'utente autenticato.',
                                    }
                                ]
                            }
                        },
                        {
                            title: 'Maggiori informazioni',
                            description: 'Per maggiori informazioni consulta la nostra <a href="/privacy-policy" class="cc-link">privacy policy</a> e la <a href="/cookie-policy" class="cc-link">cookie policy</a>.',
                        }
                    ]
                }
            },
            en: {
                "consentModal": {
                    "title": "Cookies make things better!",
                    "description": "We use first- or third-party cookies and identifiers with your consent and/or our legitimate interest to store or access information on your device, collect personal data to develop and improve products, and to display and measure advertising and/or personalized content based on your browsing (e.g. pages visited).",
                    "acceptAllBtn": "Accept all cookies",
                    "acceptNecessaryBtn": "Reject all",
                    "showPreferencesBtn": "Settings",
                    "equalWeightButtons": false
                },
                "preferencesModal": {
                    "title": "Privacy preferences center",
                    "acceptAllBtn": "Accept all",
                    "acceptNecessaryBtn": "Reject all",
                    "savePreferencesBtn": "Save settings",
                    "closeIconLabel": "Close",
                    "serviceCounterLabel": "Service|Services",
                    "equalWeightButtons": false,
                    "sections": [
                        {
                            title: 'Cookie options',
                            description: 'This website uses essential cookies to ensure proper functioning and tracking cookies to understand how you interact with it. The latter will only be set with prior consent.'
                        },
                        {
                            title: 'Strictly necessary cookies',
                            description: 'These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms. You can set your browser to block or alert you about these cookies, but as a result some parts of the site will not work. These cookies do not store any personally identifiable information.',
                            linkedCategory: 'necessary',
                            cookieTable: {
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Domain',
                                    desc: 'Description',
                                },
                                body: [
                                    {
                                        name: 'october_session',
                                        domain: window.location.hostname,
                                        desc: 'HTTP – Preserves the visitor’s session state across page requests.',
                                    },
                                    {
                                        name: 'cc_cookie',
                                        domain: window.location.hostname,
                                        desc: 'HTTP – Stores the user’s cookie consent status for the current domain.',
                                    },
                                    {
                                        name: 'user_auth',
                                        domain: window.location.hostname,
                                        desc: 'HTTP – Stores information about the authenticated user.',
                                    }
                                ]
                            }
                        },
                        {
                            title: 'More information',
                            description: 'For more information, please consult our <a href="/en/privacy-policy" class="cc-link">privacy policy</a> and <a href="/en/cookie-policy" class="cc-link">cookie policy</a>.',
                        }
                    ]
                }
            },
            es: {
                "consentModal": {
                    "title": "¡Las cookies hacen las cosas mejores!",
                    "description": "Utilizamos cookies e identificadores propios o de terceros con su consentimiento y/o nuestro interés legítimo para almacenar o acceder a información en su dispositivo, recopilar datos personales para desarrollar y mejorar productos, así como para mostrar y medir publicidad y/o contenido personalizado basado en su navegación.",
                    "acceptAllBtn": "Aceptar todas las cookies",
                    "acceptNecessaryBtn": "Rechazar todas",
                    "showPreferencesBtn": "Configuración",
                    "equalWeightButtons": false
                },
                "preferencesModal": {
                    "title": "Centro de preferencias de privacidad",
                    "acceptAllBtn": "Aceptar todas",
                    "acceptNecessaryBtn": "Rechazar todas",
                    "savePreferencesBtn": "Guardar configuración",
                    "closeIconLabel": "Cerrar",
                    "serviceCounterLabel": "Servicio|Servicios",
                    "equalWeightButtons": false,
                    "sections": [
                        {
                            title: 'Opciones de cookies',
                            description: 'Este sitio web utiliza cookies esenciales para garantizar su correcto funcionamiento y cookies de seguimiento para comprender cómo interactúas con él. Estas últimas solo se configurarán previo consentimiento.'
                        },
                        {
                            title: 'Cookies estrictamente necesarias',
                            description: 'Estas cookies son necesarias para el funcionamiento del sitio web y no pueden desactivarse en nuestros sistemas. Normalmente se configuran solo en respuesta a acciones realizadas por ti que constituyen una solicitud de servicios, como configurar tus preferencias de privacidad, iniciar sesión o completar formularios. Puedes configurar tu navegador para bloquear o alertarte sobre estas cookies, pero como consecuencia algunas partes del sitio no funcionarán. Estas cookies no almacenan información personal.',
                            linkedCategory: 'necessary',
                            cookieTable: {
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Dominio',
                                    desc: 'Descripción',
                                },
                                body: [
                                    {
                                        name: 'october_session',
                                        domain: window.location.hostname,
                                        desc: 'HTTP – Conserva el estado de la sesión del visitante entre solicitudes de página.',
                                    },
                                    {
                                        name: 'cc_cookie',
                                        domain: window.location.hostname,
                                        desc: 'HTTP – Almacena el estado del consentimiento de cookies del usuario para el dominio actual.',
                                    },
                                    {
                                        name: 'user_auth',
                                        domain: window.location.hostname,
                                        desc: 'HTTP – Almacena información sobre el usuario autenticado.',
                                    }
                                ]
                            }
                        },
                        {
                            title: 'Más información',
                            description: 'Para más información, consulta nuestra <a href="/es/privacy-policy" class="cc-link">política de privacidad</a> y la <a href="/es/cookie-policy" class="cc-link">política de cookies</a>.',
                        }
                    ]
                }
            },
            de: {
                "consentModal": {
                    "title": "Cookies machen alles besser!",
                    "description": "Wir verwenden Cookies und Kennungen von Erst- oder Drittanbietern mit Ihrer Zustimmung und/oder unserem berechtigten Interesse, um Informationen auf Ihrem Gerät zu speichern oder darauf zuzugreifen, personenbezogene Daten zu sammeln sowie Werbung und/oder personalisierte Inhalte basierend auf Ihrem Surfverhalten anzuzeigen und zu messen.",
                    "acceptAllBtn": "Alle Cookies akzeptieren",
                    "acceptNecessaryBtn": "Alle ablehnen",
                    "showPreferencesBtn": "Einstellungen",
                    "equalWeightButtons": false
                },
                "preferencesModal": {
                    "title": "Datenschutz-Einstellungen",
                    "acceptAllBtn": "Alle akzeptieren",
                    "acceptNecessaryBtn": "Alle ablehnen",
                    "savePreferencesBtn": "Einstellungen speichern",
                    "closeIconLabel": "Schließen",
                    "serviceCounterLabel": "Dienst|Dienste",
                    "equalWeightButtons": false,
                    "sections": [
                        {
                            title: 'Cookie-Optionen',
                            description: 'Diese Website verwendet essentielle Cookies, um eine ordnungsgemäße Funktion zu gewährleisten, sowie Tracking-Cookies, um zu verstehen, wie Sie mit ihr interagieren. Letztere werden nur mit vorheriger Zustimmung gesetzt.'
                        },
                        {
                            title: 'Unbedingt erforderliche Cookies',
                            description: 'Diese Cookies sind für das Funktionieren der Website erforderlich und können in unseren Systemen nicht deaktiviert werden. Sie werden in der Regel nur als Reaktion auf von Ihnen durchgeführte Aktionen gesetzt, die einer Dienstanforderung entsprechen, wie z. B. das Festlegen Ihrer Datenschutzeinstellungen, das Anmelden oder das Ausfüllen von Formularen. Sie können Ihren Browser so einstellen, dass diese Cookies blockiert oder Sie darüber informiert werden, jedoch funktionieren dann einige Teile der Website nicht mehr. Diese Cookies speichern keine personenbezogenen Daten.',
                            linkedCategory: 'necessary',
                            cookieTable: {
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Domain',
                                    desc: 'Beschreibung',
                                },
                                body: [
                                    {
                                        name: 'october_session',
                                        domain: window.location.hostname,
                                        desc: 'HTTP – Bewahrt den Sitzungsstatus des Besuchers über Seitenanfragen hinweg.',
                                    },
                                    {
                                        name: 'cc_cookie',
                                        domain: window.location.hostname,
                                        desc: 'HTTP – Speichert den Cookie-Einwilligungsstatus des Nutzers für die aktuelle Domain.',
                                    },
                                    {
                                        name: 'user_auth',
                                        domain: window.location.hostname,
                                        desc: 'HTTP – Speichert Informationen über den authentifizierten Benutzer.',
                                    }
                                ]
                            }
                        },
                        {
                            title: 'Weitere Informationen',
                            description: 'Weitere Informationen finden Sie in unserer <a href="/de/privacy-policy" class="cc-link">Datenschutzerklärung</a> und <a href="/de/cookie-policy" class="cc-link">Cookie-Richtlinie</a>.',
                        }
                    ]

                }
            },
            fr: {
                "consentModal": {
                    "title": "Les cookies rendent les choses meilleures !",
                    "description": "Nous utilisons des cookies et des identifiants internes ou tiers avec votre consentement et/ou notre intérêt légitime afin de stocker ou d’accéder aux informations sur votre appareil, collecter des données personnelles pour développer et améliorer des produits, ainsi que pour afficher et mesurer des publicités et/ou du contenu personnalisé basé sur votre navigation.",
                    "acceptAllBtn": "Tout accepter",
                    "acceptNecessaryBtn": "Tout refuser",
                    "showPreferencesBtn": "Paramètres",
                    "equalWeightButtons": false
                },
                "preferencesModal": {
                    "title": "Centre de préférences de confidentialité",
                    "acceptAllBtn": "Tout accepter",
                    "acceptNecessaryBtn": "Tout refuser",
                    "savePreferencesBtn": "Enregistrer les paramètres",
                    "closeIconLabel": "Fermer",
                    "serviceCounterLabel": "Service|Services",
                    "equalWeightButtons": false,
                    sections: [
                        {
                            title: 'Options des cookies',
                            description: 'Ce site web utilise des cookies essentiels pour garantir son bon fonctionnement et des cookies de suivi afin de comprendre comment vous interagissez avec lui. Ces derniers ne seront installés qu’avec votre consentement préalable.'
                        },
                        {
                            title: 'Cookies strictement nécessaires',
                            description: 'Ces cookies sont nécessaires au fonctionnement du site web et ne peuvent pas être désactivés dans nos systèmes. Ils sont généralement définis uniquement en réponse aux actions que vous effectuez et qui constituent une demande de services, telles que le paramétrage de vos préférences de confidentialité, la connexion ou le remplissage de formulaires. Vous pouvez configurer votre navigateur pour bloquer ou vous avertir de l’utilisation de ces cookies, mais certaines parties du site risquent alors de ne pas fonctionner correctement. Ces cookies ne stockent aucune information personnelle.',
                            linkedCategory: 'necessary',
                            cookieTable: {
                                headers: {
                                    name: 'Cookie',
                                    domain: 'Domaine',
                                    desc: 'Description',
                                },
                                body: [
                                    {
                                        name: 'october_session',
                                        domain: window.location.hostname,
                                        desc: 'HTTP – Conserve l’état de la session du visiteur entre les requêtes de pages.',
                                    },
                                    {
                                        name: 'cc_cookie',
                                        domain: window.location.hostname,
                                        desc: 'HTTP – Stocke l’état du consentement aux cookies de l’utilisateur pour le domaine actuel.',
                                    },
                                    {
                                        name: 'user_auth',
                                        domain: window.location.hostname,
                                        desc: 'HTTP – Stocke des informations sur l’utilisateur authentifié.',
                                    }
                                ]
                            }
                        },
                        {
                            title: 'Plus d’informations',
                            description: 'Pour plus d’informations, consultez notre <a href="/fr/privacy-policy" class="cc-link">politique de confidentialité</a> et notre <a href="/fr/cookie-policy" class="cc-link">politique relative aux cookies</a>.',
                        }
                    ]

                }
            }
        }
    }
});

const updateGtagConsent = () => {
    const consentMode = {
        'ad_storage': CookieConsent.acceptedCategory('targeting') ? 'granted' : 'denied',
        'ad_user_data': CookieConsent.acceptedCategory('targeting') ? 'granted' : 'denied',
        'ad_personalization': CookieConsent.acceptedCategory('targeting') ? 'granted' : 'denied',
        'analytics_storage': CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
        'functionality_storage': CookieConsent.acceptedCategory('functional') ? 'granted' : 'denied',
        'personalization_storage': CookieConsent.acceptedCategory('functional') ? 'granted' : 'denied',
        'security_storage': 'granted', //necessary
        // 'region': ['IT', 'ES','AL','AT','BE','BG']
        // 'wait_for_update': 500
    };

    gtag('consent', 'update', consentMode);
};

const updateFBConsent = () => {
    fbq('consent', CookieConsent.acceptedCategory('targeting') ? 'grant' : 'revoke');
};

function registerCookiePreference() {
    let cookiEntries = {
        'targeting': CookieConsent.acceptedCategory('targeting') ? '1' : '0',
        'analytics': CookieConsent.acceptedCategory('analytics') ? '1' : '0',
    }

    $.request('onLogEntries',{
        data: {cookiEntries: cookiEntries},
    })
}

